// Polyfills.
import 'react-app-polyfill/ie11';
import 'babel-polyfill';

// Modules.
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

// Sections.
import App from './sections/App';

// Redux.
import store from './redux/store';

// Global styles.
import './index.scss';

// Service Workers.
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
    <Provider store={ store }>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
